import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { forkJoin, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { AlertService } from '../../commons/services/alert.service';
import { AppState } from '../reducers';
import { getSelectedStoreTenant } from '../selectors/tenant.selectors';
import { getStatisticsState } from '../selectors/statistics.selectors';

import * as StatisticsActions from '../actions/statistics.actions';
import { LaravelStatisticService } from '../../commons/services/laravel/laravel-statistic.service';

@Injectable()
export class StatisticsEffects {

    error$ = createEffect(
        () =>
          this.actions$.pipe(
            ofType(
                StatisticsActions.loadOrderStatisticsFailed,
                StatisticsActions.loadProductStatisticsFailed,
                StatisticsActions.loadZoneStatisticsFailed,
                StatisticsActions.loadTotalStatisticsFailure
            ),
            tap(({ error }) => {
              if (error) {
                this.alertService.showErrorMessage('Errore', error);
              }
            })
          ),
        { dispatch: false }
    );

    loadOrderStatistics$ = createEffect(() =>
      this.actions$.pipe(
        ofType(StatisticsActions.loadOrderStatistics),
        mergeMap(({ startDate, endDate, isDelivery, isTakeAway, tenant_id }) =>
          this.statisticsService.orders(isDelivery, isTakeAway, tenant_id, startDate, endDate).pipe(
            map(orders => {
              //console.log('Dati ricevuti:', orders);
              return StatisticsActions.loadOrderStatisticsCompleted({ 
                orders, 
                startDate, 
                endDate, 
                isDelivery, 
                isTakeAway, 
                tenant_id 
              });
            }),
            catchError((error) =>
              of(StatisticsActions.loadOrderStatisticsFailed({ error }))
            )
          )
        )
      )
    );
    



    // loadStatistics$ = createEffect(() => 
    //     this.actions$.pipe(
    //       ofType(StatisticsActions.loadTotalStatistics),
          
    //       switchMap(({ startDate, endDate }) => 
    //         this.store$.select(getSelectedStoreTenant).pipe(
    //           switchMap((selectedTenant) => {
    //             const tenant_id = selectedTenant?.id ?? null;
    //             //console.log("🟡 selectedTenant:", selectedTenant);
    //             //console.log("Tenant_id nel effect di statistics:", tenant_id);
        
    //             // Se c'è un tenant_id, lo usiamo, altrimenti eseguiamo la chiamata globale
    //             return forkJoin({
    //               orders: this.statisticsService.orders(
    //                 true, // isDelivery
    //                 true, // isTakeAway
    //                 tenant_id,
    //                 new Date(startDate),  // startDate
    //                 new Date(endDate),    // endDate
    //                 false   // exportCSV
    //               ),
    //               topSelling: this.statisticsService.topSelling(
    //                 new Date(startDate),
    //                 new Date(endDate),
    //                 false, // exportCSV
    //                 tenant_id 
    //               ),
    //               zones: this.statisticsService.zones(
    //                 new Date(startDate),
    //                 new Date(endDate),
    //                 false, // exportCSV
    //                 tenant_id
    //               ),
    //             }).pipe(
    //               map(({ orders, topSelling, zones }) => 
    //                 StatisticsActions.loadStatisticsCompleted({ orders, topSelling, zones })
    //               ),
    //               catchError((error) => 
    //                 of(StatisticsActions.loadStatisticsFailed({ error }))
    //               )
    //             );
    //           })
    //         )
    //       )
    //     )
    // );

    loadTopSelling$ = createEffect(() =>
      this.actions$.pipe(
        ofType(StatisticsActions.loadProductStatistics),
        mergeMap(({ startDate, endDate, tenant_id }) =>
          this.statisticsService.topSelling(startDate, endDate, tenant_id).pipe(
            map( products => {
              return StatisticsActions.loadProductStatisticsCompleted({
                products,
                startDate,
                endDate,
                tenant_id
              });
            }),
            catchError((error) =>
              of(StatisticsActions.loadProductStatisticsFailed({ error }))
            )
          )
        )
      )
    );
    
    loadZoneStatistics$ = createEffect(() =>
      this.actions$.pipe(
        ofType(StatisticsActions.loadZoneStatistics),
        mergeMap(({ startDate, endDate, tenant_id }) =>
          this.statisticsService.zones(startDate, endDate, tenant_id).pipe(
            map(zones => {
              return StatisticsActions.loadZoneStatisticsCompleted({
                zones,
                startDate,
                endDate,
                tenant_id
              });
            }),
            catchError((error) =>
              of(StatisticsActions.loadZoneStatisticsFailed({ error }))
            )
            )
          )
        )
    );
    




  // Carica le statistiche
//   loadStatistics$ = createEffect(() =>
//     this.actions$.pipe(
//       ofType(StatisticsActions.loadTotalStatistics),
//       withLatestFrom(this.store$.select(getSelectedStoreTenant)),
//       map(([{ filters }, tenant]) => {
//         const tenantId = tenant ? tenant.id : null;
//         const updatedFilters = { ...filters, tenant_id: tenantId };
//         return { filters: updatedFilters };
//       }),
//       switchMap(({ filters }) =>
//         forkJoin({
//           orders: this.statisticsService.orders(
//             filters.isDelivery, 
//             filters.isTakeAway, 
//             filters.tenant_id, 
//             filters.startDate, 
//             filters.endDate
//           ),
//           topSelling: this.statisticsService.topSelling(
//             filters.startDate, 
//             filters.endDate,
//             false,
//             filters.tenant_id
//           ),
//           zones: this.statisticsService.zones(
//             filters.startDate, 
//             filters.endDate,
//             false,
//             filters.tenant_id
//           )
//         }).pipe(
//           map(({ orders, topSelling, zones }) => 
//             StatisticsActions.loadStatisticsCompleted({
//               orders,
//               topSelling,
//               zones
//             })
//           ),
//           catchError((error) => 
//             of(StatisticsActions.loadStatisticsFailed({ error }))
//           )
//         )
//       )
//     )
//   );

//   // Salvataggio delle statistiche
//   saveStatistics$ = createEffect(() =>
//     this.actions$.pipe(
//       ofType(StatisticsActions.saveStatistics),
//       withLatestFrom(this.store$.select(getSelectedStoreTenant)),
//       mergeMap(([{ statistics }, selectedTenant]) => {
//         const tenantId = selectedTenant ? selectedTenant.id : null;
//         const statisticsToSave = { ...statistics, tenant_id: tenantId };
//         return this.statisticsService.saveStatistics(statisticsToSave).pipe(
//           map((savedStatistics) =>
//             StatisticsActions.saveStatisticsCompleted({ statistics: savedStatistics })
//           ),
//           catchError((error) =>
//             of(StatisticsActions.saveStatisticsFailed({ error }))
//           ),
//           tap((action) => {
//             if (action.type === StatisticsActions.saveStatisticsCompleted.type) {
//               this.alertService.showConfirmMessage('Statistiche salvate con successo');
//             }
//           })
//         );
//       })
//     )
//   );

  

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    private statisticsService: LaravelStatisticService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {}
}
